import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { EgonDeliveriesStateType, EgonDeliveryType } from 'src/types/egonRoute';

const initialState: EgonDeliveriesStateType = {
    data: null,
    loading: false,
    error: false,
};

export const egonDeliveriesSlice = createSlice({
    name: 'egonDeliveries',
    initialState,
    reducers: {
        getEgonDeliveriesFetch: (state) => {
            state.loading = true;
            state.error = false;
        },
        getEgonDeliveriesFetchSuccess: (state, action: PayloadAction<EgonDeliveryType[]>) => {
            state.data = action.payload;
            state.loading = false;
        },
        getEgonDeliveriesFetchFailure: (state) => {
            state.data = null;
            state.loading = false;
            state.error = true;
        },
    },
});

export const { getEgonDeliveriesFetch, getEgonDeliveriesFetchSuccess, getEgonDeliveriesFetchFailure } =
    egonDeliveriesSlice.actions;

export default egonDeliveriesSlice.reducer;
